import { AsyncPipe, CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { FormsModule } from '@angular/forms';

import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatRadioModule } from '@angular/material/radio';
import { MatSelectModule } from '@angular/material/select';
import { MatTooltipModule } from '@angular/material/tooltip';
import { TranslateModule, TranslateService } from '@ngx-translate/core';

import { StateService } from '../../../core/data-access/state.service';
import { ChatMode, ModelType, SearchMode } from 'src/app/shared/model/query-body.model';
import { SliderComponent } from '../../../shared/ui/slider/slider.component';

@Component({
  selector: 'app-settings',
  standalone: true,
  imports: [
    AsyncPipe,
    CommonModule,
    MatRadioModule,
    FormsModule,
    MatFormFieldModule,
    MatSelectModule,
    MatCheckboxModule,
    MatIconModule,
    MatTooltipModule,
    TranslateModule,
    SliderComponent
  ],
  templateUrl: './settings.component.html',
  styleUrls: ['./settings.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class SettingsComponent {
  private stateService = inject(StateService);
  translateService = inject(TranslateService);

  SearchMode: SearchMode;
  ChatMode: ChatMode;
  ModelType = ModelType;

  searchMode: string = SearchMode.HYBRID;
  searchModes: string[] = [
    SearchMode.HYBRID,
    SearchMode.SEMANTIC,
    SearchMode.TEXT
  ];


  chatMode: string = ChatMode.OPENAI;
  chatModes: string[] = [
    ChatMode.OPENAI,
    ChatMode.CONDENSE_PLUS_CONTEXT,
  ];


  selectedConfiguration = this.stateService.selectedConfiguration$;
  selectedModel$ = this.stateService.selectedModel$;
  selectedModel = this.selectedModel$.value;

  onSelectModel(event$: ModelType) {
    this.selectedModel = event$;
    this.stateService.updateSelectedModel(event$);
  }

  updateSearchMode($event: SearchMode) {
    this.stateService.updateSearchMode($event);
  }

  updateChatMode($event: ChatMode) {
    this.stateService.updateChatMode($event);
  }
}
